/* istanbul ignore file */

import { VGS } from '@lib/vgs'

/**
 * Custom VGS error classes for better error handling
 * These allow us to use instanceof checks instead of parsing error messages
 */

export class VgsFieldValidationError extends Error {
  constructor() {
    super('field validation failed')
    this.name = 'VgsFieldValidationError'
  }
}

export class VgsRequiredFieldError extends VgsFieldValidationError {
  constructor() {
    super()
    this.name = 'VgsRequiredFieldError'
  }
}

export class VgsInvalidCardError extends VgsFieldValidationError {
  constructor() {
    super()
    this.name = 'VgsInvalidCardError'
  }
}

/**
 * Factory function to create appropriate VGS error based on error content
 */
export function createVgsError(vgsError: any): VgsFieldValidationError {
  const fieldErrors: VGS.State = vgsError || {}

  let hasRequiredError = false
  let hasInvalidError = false

  Object.entries(fieldErrors).forEach(([fieldName, fieldData]) => {
    if (fieldName && fieldData && typeof fieldData === 'object') {
      const stateItem = fieldData as VGS.StateItem
      const fieldErrorObjects: VGS.Field.Error[] = stateItem.errors || []

      const fieldHasRequired = fieldErrorObjects.some((err: VGS.Field.Error) => err.code === 1001)
      const fieldHasInvalid = fieldErrorObjects.some((err: VGS.Field.Error) => err.code === 1011)

      if (fieldHasRequired) hasRequiredError = true
      if (fieldHasInvalid) hasInvalidError = true
    }
  })

  if (hasRequiredError) {
    return new VgsRequiredFieldError()
  }

  if (hasInvalidError) {
    return new VgsInvalidCardError()
  }

  return new VgsFieldValidationError()
}
